namespace('compass.hotel');

compass.hotel.HotelFilter = function HotelFilter(excluded, included, sorter, redraw) {

	var _hotels = [ ];
	var _filterMap = { };
	var _minSlidingPrice = 999999;
	var _maxSlidingPrice = 0;
	var _minRangePrice = 0;
	var _maxRangePrice = 999999;
	var _excluded = excluded;
	var _included = included;

	var _sorter = sorter || function() {};
	var _redraw = redraw || function() {};
	var _lastSortDir = 0;
	var _processingRequest = false;
	var me = this;
	var _availStatus = {FULL : 'FULL', LIMITED : 'LIMITED', UNAVAILABLE: 'UNAVAILABLE'};
	var _rangeKey = false;
	var _spinnerMinimumDisplayTime = 750;

	// map of '03/23/13-03/25/13'->[callback1, callback2]
	// where callback1 is the HotelFilter.applyFilter() method of the instance inside of HotelListWidget. It will call the correct show/hide methods to show/hide hotel cards
	// and callback2 is the HotelFilter.applyFilter() method of the indstance of BigMapWidget. It will call the correct show/hide methods to show hide map pins
	compass.hotel.HotelFilter.availMap = compass.hotel.HotelFilter.availMap || {};

	me.setData = function(hotels) {
		_hotels = hotels;
		_filterMap = { };
		_minRangePrice = 0;
		_maxRangePrice = 999999;
		_minSlidingPrice = 999999;
		_maxSlidingPrice = 0;
		for(var i in _hotels) {
			var price = Number(_hotels[i].lowestAvgRateNumeric);
			if(price < _minSlidingPrice) { _minSlidingPrice = price; }
			if(price > _maxSlidingPrice) { _maxSlidingPrice = price; }
		}
	};

	function _starOptions(filterObj) {
		return _.map(_.filter(_.values(filterObj),
				function(x) { return x.type == 'stars' && x.value; }),
						function(x) { return x.key; });
	}

	function getAvailabilityStatus(availMin, singleBlockMax, multiBlockMax){
		if (availMin <= singleBlockMax){
			return _availStatus.FULL; // they can book with just one block
		}
		else if(availMin >= singleBlockMax && availMin <= multiBlockMax){
			return _availStatus.LIMITED; // they have to book across multiple blocks
		}
		else{
			return _availStatus.UNAVAILABLE; // they can't book availMin contiguous reservations, even across multiple blocks
		}
	}

	// funciton assumes that correct arriveDate and departDate are always passed in
	// whether it's default arrive/depart or ones actually entered by the user
	function _availFilter(filterObj, arriveDate, departDate) {
		var numOfRoomsFilter = _.find(filterObj, function (f) { return f.key === 'availability'; });
		if (!numOfRoomsFilter) {
			return function (a) { return false; };
		}

		var availMin = Math.round(numOfRoomsFilter.value);
		return function avFilt (hotel) {
			// compare the value of availMin to that maximumOneBlockReservations across date range and maxMultiBlockReservations across date range
			if (availMin === 0) { return false; } //  don't hide any hotels since they have the slider all the way to the left (value of 0, even though it shows 1)
			if(hotel.avail.status === 'GDS' || hotel.avail.status === 'SOLDOUT'){
				return true; //hide
			}
			else{
				var availStatus = getAvailabilityStatus(availMin, 
					hotel.avail.maxOneBlockReservations, 
					hotel.avail.maxMultiBlockReservations);
				if(availStatus == _availStatus.FULL || availStatus == _availStatus.LIMITED){
					return false;// show
				}
				else{
					return true;// hide because we can't satisfy the user's request, even across multiple blocks
				}
			}
		};
	}

	me._applyFilter = function(hotels, filterObj, initComparator, dimHotels){
		var animQueue = { };
		var priceFilter = null;
		var priceRangeFilter = null;
		var starCutoffFilter = null;
		var availFilter = _availFilter(filterObj);
		var distanceSort = null;
		var priceSort = null;
		var starOptions = _starOptions(filterObj);
		var numOfRoomsFilter = _.find(filterObj, function (f) { return f.key === 'availability'; });
		var availMin = 0;
		var dimHotels = dimHotels || false;
		if(numOfRoomsFilter){
			availMin = Math.round(numOfRoomsFilter.value);
		}

		function starFilter(hotel) {

			var starDisplay;
			if (hotel.starRatingDecimal > 0) {
				starDisplay = hotel.starRatingDecimal;
			} else {
				starDisplay = hotel.starRating;
			}

			return starOptions.length !== 0 && !_.any(starOptions, function(s) { return s === Math.floor(starDisplay); });
		}
		var excludes = { };

		me.setData(hotels);
		// redraw each hotel (hotel card/pin, etc) based on the newest data and the current minimum number of rooms needed
		_redraw(hotels, availMin, dimHotels);

		// loop through each hotel
		_.each(hotels, function(hotel) {
			var hotelId = hotel.hotelId;
			var allPromos = false;

			// for each loop through each filter criterion
			for(var filter in filterObj) {
				// for each filter criterion, determine whether we will queue the hotel for hiding later (in the case of price and distance)
				// or now the current hotel later (in the case of amenities and keywords)
				// note...excluded, included are functions that are called when a hotel is to be shown or hidden
				var key = filterObj[filter].key;
				var value = filterObj[filter].value;
				var type = filterObj[filter].type;

				if (type == 'promo') {
					if (key == 'All Exclusive Promotions') {
						allPromos = true;
					}
					// hotels should be excluded if All is selected but it has no promotions at all 
					// OR if All is NOT selected, then only hotels that have all of the selected incentives should be displayed
					if ((allPromos && !hotel.promotions.length) || (!allPromos && _filtered(hotel, key, value, type))) {
						animQueue[hotelId] = _excluded(hotelId, dimHotels);
						excludes[hotelId] = excludes[hotelId] || {};
						excludes[hotelId][key] = value;
					}
				} else {
					if (key == 'price') {
						// determine that one of the things we are filtering is the price. Note, this is not the same as the _priceFilter function which actually determines
						// if a hotel should be excluded based on its price. priceFilter is just a boolean to see if we will do this filtering at all.
						priceFilter = filterObj[filter];
					}
					else if (key == 'minRangePrice' || key == 'maxRangePrice') {
						priceRangeFilter = filterObj[filter];
						if (key == 'minRangePrice') {
							_minRangePrice = parseInt(value);
						}
						if (key == 'maxRangePrice') {
							_maxRangePrice = parseInt(value);
						}
					}
					else if (key == 'distance') {
						// boolean that tells us whether we will sort by distance
						distanceSort = value;
					}
					else if (key == 'starCutoff') {
						starCutoffFilter = filterObj[filter];
					} else if (key == 'priceLowToHigh') {
						// int that tells us whether we will sort price $-$$$
						priceSort = -1;
					} else if (key == 'priceHighToLow') {
						// int that tells us whether we will sort price $-$$$
						priceSort = 1;
					} else if(key == 'aiSearch') {
						let hotelMatch = value.some(aiHotelId => hotelId == parseInt(aiHotelId));

						if (!hotelMatch) {
							animQueue[hotelId] = _excluded(hotelId, dimHotels);
							excludes[hotelId] = excludes[hotelId] || {};
							excludes[hotelId][key] = value;
						}
					} else if (_filtered(hotel, key, value, type)) {
						animQueue[hotelId] = _excluded(hotelId, dimHotels);
						excludes[hotelId] = excludes[hotelId] || {};
						excludes[hotelId][key] = value;
						break;
					}
				}
			}

			// show/hide current hotel depending on number of rooms requested
			if(availFilter(hotel)) {
				animQueue[hotelId] = _excluded(hotelId, dimHotels);
				excludes[hotelId] = excludes[hotelId] || {};
				excludes[hotelId].avail = true;
			}

			// show/hide current hotel based on star rating. Not the same as the 'Star Cutoff' filter!!
			if(starFilter(hotel)) {
				animQueue[hotelId] = _excluded(hotelId, dimHotels);
				excludes[hotelId] = excludes[hotelId] || {};
				excludes[hotelId].stars = true;
			}

			// if we have not queued this hotel for hiding, then queue it for showing
			if(animQueue[hotelId] === undefined) {
				// udpate the minimum and maximum prices if this hotel happens to be the cheapest or most expenisve so far
				var price = Number(hotel.avail.lowestAvgRateNumeric);
				if (price < _minSlidingPrice) { _minSlidingPrice = price; }
				if (price > _maxSlidingPrice) { _maxSlidingPrice = price; }
				//
				animQueue[hotelId] = _included(hotelId, dimHotels);
			}
		}); // end of first hotel loop

		// if we have previously determined to hide hotels by price, loop thorugh hotels again and queue each one for hiding based on price
		// there's a gotcha here in that priceFilter will never exclude EVERY hotel, it always leaves off at least one.
		var sortDir = 0;
		if(priceFilter) {
			sortDir = priceFilter.value < 0.5 ? -1 : (priceFilter.value > 0.5 ? 1 : 0);
			_.each(hotels, function(h) {
				if(_priceFilter(h, priceFilter.key, priceFilter.value, priceFilter.type)) {
					animQueue[h.hotelId] = _excluded(h.hotelId, dimHotels);
					excludes[h.hotelId] = excludes[h.hotelId] || {};
					excludes[h.hotelId].price = true;
				}
			});
		}

		// if we have previously determined to hide hotels by price range, loop through hotels again and queue each one for hiding based on price
		// unlike the other price filter, this one can filter out every single hotel if none of them fall within the given price range
		if (priceRangeFilter) {
			_.each(hotels, function(h) {
				if(_priceRangeFilter(h, priceRangeFilter.key, priceRangeFilter.value, priceRangeFilter.type)) {
					animQueue[h.hotelId] = _excluded(h.hotelId, dimHotels);
					excludes[h.hotelId] = excludes[h.hotelId] || {};
					excludes[h.hotelId].price = true;
				}
			});
		}

		// unlike the 'star options' filter, the star cutoff filter only exludes hotels below the specified value
		if (starCutoffFilter) {
			_.each(hotels, function(h) {
				if(_starCutoffFilter(h, starCutoffFilter.key, starCutoffFilter.value, starCutoffFilter.type)) {
					animQueue[h.hotelId] = _excluded(h.hotelId, dimHotels);
					excludes[h.hotelId] = excludes[h.hotelId] || {};
					excludes[h.hotelId].stars = true;
				}
			});
		}

		//bound in view
		$('#viewport').trigger( {type:'hotelsFiltered', hotelsFiltered:excludes, availMin:availMin, dateRange:_rangeKey } );

		// actually show or hide each hotel. 
		for(var i in animQueue) {
			var anim = animQueue[i];
			if(anim) { anim(); }
		}

		// _sorter is a function that was passed into this object, it accepts 1 argument...a comparator function. It will visually rearrange hotels.
		// we are calling that function here and passing into it a comparator function...the anonmyous function(a,b){...}
		_sorter(function(a, b) {
			var sortByPrice = function(a, b, sortDir) {
				return a.avail.lowestAvgRateNumeric < b.avail.lowestAvgRateNumeric ? sortDir :
					(b.avail.lowestAvgRateNumeric < a.avail.lowestAvgRateNumeric ? sortDir * -1 : 0);
			};

			var sortByName = function(a, b) {
				var hotelNameA = a.name.toLowerCase();
				var hotelNameB = b.name.toLowerCase();
				return hotelNameA < hotelNameB ? -1 : 1;
			};

			//Custom gallery cards top always floats to the top
			if(a.avail.status == 'TOP') {
				return -1;
			}
			else if(b.avail.status == 'TOP') {
				return 1;
			}
			//Show Unavailable at the end
			else if(a.avail.status == 'SOLDOUT' && b.avail.status != 'SOLDOUT'){
				return 1; // b should come before a
			}
			else if(a.avail.status != 'SOLDOUT' && b.avail.status == 'SOLDOUT'){
				return -1; //  a should come before b
			}

			if(a.avail.status == 'BOTTOM') {
				return 1;
			}
			else if(b.avail.status == 'BOTTOM') {
				return -1;
			}
			else if(a.avail.status == 'SOLDOUT' && b.avail.status != 'SOLDOUT'){
				return 1; // b should come before a
			}
			else if(a.avail.status != 'SOLDOUT' && b.avail.status == 'SOLDOUT'){
				return -1; //  a should come before b
			}

			if (distanceSort) {
				if (a.sortOrder || b.sortOrder) {
					if (a.sortOrder == '') {
						return 1;
					} else if (b.sortOrder == '') {
						return -1;
					} else {
						return a.sortOrder < b.sortOrder ? -1 : 1;
					}
				} else if (a.categoryPreferredHotel || b.categoryPreferredHotel) {
					if (a.categoryPreferredHotel === b.categoryPreferredHotel) {
						sortByName(a,b);
					} else {
						return a.categoryPreferredHotel ? -1 : 1;
					}
				} else if (a.hqHotel || b.hqHotel) {
					if (a.hqHotel === b.hqHotel) {
						sortByName(a,b);
					} else {
						return a.hqHotel ? -1 : 1;
					}
				}
				else {
					if (a.distanceUnits == b.distanceUnits) {
						//sort by distance then price if applicable
						return a.distance < b.distance ? -1 :
							(b.distance < a.distance ? 1 : sortByPrice(a, b, sortDir));
					}
					else {
						//distance units priority: blocks < miles < everything else
						if (a.distanceUnits == 'Blocks' || b.distanceUnits == 'Blocks') {
							return a.distanceUnits == 'Blocks' ? -1 : 1;
						}
						else if (a.distanceUnits == 'Miles' || b.distanceUnits == 'Miles') {
							return a.distanceUnits == 'Miles' ? -1 : 1;
						}
						else {
							return 0;
						}
					}
				}
			} else if (priceSort) {
				return sortByPrice(a, b, priceSort);
			} else if (sortDir !== 0) {
				return sortByPrice(a, b, sortDir);
			}
			else {
				return initComparator ? initComparator(a, b) : 0;
			}
		});
		
		_lastSortDir = sortDir;
	};

	var dateRangeKey = function(arrive, depart){
		return arrive + ':' + depart;
	};

	this.updateFilter = function(filterObj, initComparator, requireCheckInOutDates) {
		var arrive = _.findWhere(filterObj, {key:'arrive'});
		var depart = _.findWhere(filterObj, {key:'depart'});
		var dimHotels = false;

		// Cancel applying filters if initial check in/out dates are required and not set yet
		if (true === requireCheckInOutDates && (!arrive || !depart) ){
			return false;
		}

		// the whole point here is to not call ajax request for date ranges that have already been requested
		// this function can be called while the first ajax request is still running so we need to save the applyFilter calls for when the ajax
		// request actually finishes. Once it does, we just reuse the data for that date range and just call apply filter from that point on.
		if(arrive && depart){
			var _rangeKey = dateRangeKey(arrive.value, depart.value);
			var rangeKey = _rangeKey;
			var availObject = compass.hotel.HotelFilter.availMap[rangeKey];
			dimHotels = true;
			if(availObject){
				// we started a request that has not come back yet, just append the apply filter method as the callback that will eventually get called when the ajax 
				// success fires
				if(!availObject.data){
					//availObject.callbacks.push(this._applyFilter(_hotels, filterObj, initComparator));
					availObject.callbacks.push(me._applyFilter); 
				}
				else{
					// the success function fired already, so just reuse the data to apply the filter. 
					// we prevent an unnecessary ajax request thanks to this
					this._applyFilter(availObject.data, filterObj, initComparator, dimHotels);

				}
			}
			else{
				// push the first callback and make the ajax request
				compass.hotel.HotelFilter.availMap[rangeKey] = {callbacks: []};
				compass.hotel.HotelFilter.availMap[rangeKey].callbacks.push(me._applyFilter);

				// first time making an avail ajax request

				$('body').trigger({ type:'availActive' });

				// Show a spinner just before calling avail
				// Also track the time it was created so we can ensure a minimum display time
				var spinnerDisplayedTimestamp = Date.now();
				var spinnerDiv = jQuery.dom.div();
				compass.loading.start(spinnerDiv);
				var loadingDialog = jQuery.dom.dialog({
					width : 0,
					centerOnView : true,
					classes : 'HotelListWidget loadingDialog',
					contents: spinnerDiv,
					showCloseButton: false,
					disableClicksOutsideModal : true
				});
				var removeSpinner = function () {
					compass.loading.stop();
					loadingDialog.close();
				};

				jQuery.ajax({
					url : '/avail',
					data: {
						'arrive': arrive.value,
						'depart': depart.value
					},
					dataType: 'json',
					success : function(availData) {

						var doDisplayUpdate = function () {
							removeSpinner();
							$('body').trigger({ type:'availDataChange', availData:availData });
							
							compass.hotel.HotelFilter.availMap[rangeKey].data = availData.hotels;
							
							// now we have a bunch of date range entries with its corresponding data and an array of callbacks
							// the callbacks should be called in succession 
							_.each(compass.hotel.HotelFilter.availMap[rangeKey].callbacks, function(currentCallback){
								currentCallback(compass.hotel.HotelFilter.availMap[rangeKey].data, filterObj, initComparator, dimHotels);
							});
							// clear the callbacks but leave the data alone to be able to be reused later
							compass.hotel.HotelFilter.availMap[rangeKey].callbacks = [];
						};
						
						// Calculate the required delay to meet the minimum time
						// Delay the removal if required
						var spinnerDisplayTime = Date.now() - spinnerDisplayedTimestamp;
						var requiredDelayTime = _spinnerMinimumDisplayTime -spinnerDisplayTime;
						
						if (requiredDelayTime > 0) {
							setTimeout(doDisplayUpdate, requiredDelayTime);
						} else {
							doDisplayUpdate();
						}
					},
					// This is acting as an error handler, but not stopping the default ajax error behavior
					complete : function(jqXHR) {
						if (jqXHR.status !== 200) {
							removeSpinner();
						}
					}
				});
			}
		}
		else{
			// we didn't have both arrive and depart in the list of filters but there may be others
			me._applyFilter(_hotels, filterObj, initComparator, dimHotels);
		}

	};

	function _filtered(hotel, key, value, type) {
		return _promoFilter(hotel, key, value, type) ||
				_amenityFilter(hotel, key, value, type) ||
				_queryFilter(hotel, key, value, type) ||
				_hotelChainFilter(hotel, key, value, type) ||
				_hotelEcoCertificationFilter(hotel, key, value, type);
	}

	function _amenityFilter(hotel, key, value, type) {
		return type == 'amenity' && value &&
				!_.any(hotel.amenities, function(a) { return a.type == key; });
	}

	function _promoFilter(hotel, key, value, type) {
		return type == 'promo' && value && !_.any(hotel.promotions, function(a) { 
			return a.type == key; });
	}

	// filters prices on a sliding scale from 0..1
	function _priceFilter(hotel, key, value, type) {
		if(value < 0.5) {
			var cutoff = Math.ceil(_minSlidingPrice + (_maxSlidingPrice - _minSlidingPrice) * value * 2);
			var price = Number(hotel.avail.lowestAvgRateNumeric);
			return price > cutoff;
		} else if(value > 0.5) {
			var cutoff = Math.floor(_maxSlidingPrice - (_maxSlidingPrice - _minSlidingPrice) * (1 - value) * 2);
			var price = Number(hotel.avail.lowestAvgRateNumeric);
			return price < cutoff;
		} else {
			return false;
		}
	}

	// filters prices via absolute minimum & maximum integer values
	function _priceRangeFilter(hotel, key, value, type) {
		var price = Number(hotel.avail.lowestAvgRateNumeric);
		return (price < _minRangePrice) || (price > _maxRangePrice);
	}

	function _starCutoffFilter(hotel, key, value, type) {
		var rating = (hotel.starRatingDecimal > 0) ? hotel.starRatingDecimal : hotel.starRating;
		return rating < value;
	}

	function _hotelChainFilter(hotel, key, value, type) {
		return key === 'hotelChain' ? hotel.hotelChain !== value : false;
	}

	function _hotelEcoCertificationFilter(hotel, key, value, type) {
		return key === 'ecoCertified' ? !hotel.isEcoCertified : false;
	}

	function _queryFilter(hotel, key, value, type) {
		// Need to ensure 'value' is a string before running .replace method on it
		if ((typeof(value))==='string') {
			//If user enters in a special character will change from special char to a space
			var noSpecialChars = value.replace(/[^\w&\s,'/]/g, "");
			//Hotel name is loaded with the & as &amp; - replacing that with an & for searching
			var replaceAmpersand = noSpecialChars.replace('&', '&amp;');
			var regex = new RegExp('.*' + replaceAmpersand + '.*', 'i');
		} else {
			var regex = new RegExp('.*' + value + '.*', 'i');
		}
		return key == 'query' && !hotel.name.match(regex);
	}

	function _updateFilterMap(key, hotelId, filtered) {
		var map = _filterMap[key];
		if(map === undefined) {
			map = _filterMap[key] = { };
		}
		map[hotelId] = filtered;
	}

};

compass.hotel.HotelFilter.availMap = compass.hotel.HotelFilter.availMap || {};